import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
export const { DefaultToSUpdateNoticeTID } = getTestIds();
export const DefaultToSUpdateNotice = (param)=>{
    let { onDismiss, onViewUpdatedTerms } = param;
    const { t: texts } = useLocaleKeys('components.legalTermsDropdown.announcementModal');
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'default_tos_announcement_view_updated'
            },
            secondaryButton: {
                name: 'default_tos_announcement_dismiss'
            }
        },
        title: texts.title(),
        width: "620px",
        testId: DefaultToSUpdateNoticeTID.Root(),
        textAlignCenter: false,
        content: /*#__PURE__*/ _jsx(Typography, {
            children: texts.body()
        }),
        primaryButtonLabel: texts.viewUpdatedTermsCta(),
        secondaryButtonLabel: texts.dismissCta(),
        onPrimaryButtonClick: onViewUpdatedTerms,
        onSecondaryButtonClick: onDismiss
    });
};
